import React from "react";

function PythonTestCases({
  testCases = [],
  disabled = false,
  handleTestCaseValueChange,
  handleTestCaseOutputChange,
  addTestCaseValue,
  removeTestCaseValue,
  addTestCase,
  removeTestCase,
  onMetaChange,
}) {
  return (
    <div className="mb-2">
      <h5 className="text-muted">Test cases:</h5>
      {testCases.map((testCase, testCaseIndex) => (
        <div key={testCaseIndex} className="test-case mt-3 position-relative">
          <button
            type="button"
            className="btn-close bg-danger position-absolute top-0 end-0"
            aria-label="Close"
            disabled={disabled}
            onClick={() => removeTestCase(testCaseIndex)}
          />
          {typeof onMetaChange === "function" && (
            <>
              <div className="form-group">
                <label>Title:</label>
                <input
                  type="text"
                  className="form-control custom-input"
                  value={testCase.title || ""}
                  disabled={disabled}
                  placeholder={`Test case ${testCaseIndex + 1}`}
                  onChange={(event) => onMetaChange(testCaseIndex, { title: event.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Description:</label>
                <textarea
                  rows="2"
                  className="form-control custom-input"
                  value={testCase.description || ""}
                  disabled={disabled}
                  placeholder="What this test checks"
                  onChange={(event) => onMetaChange(testCaseIndex, { description: event.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Assertion keywords (comma-separated, py-executor style):</label>
                <input
                  type="text"
                  className="form-control custom-input"
                  value={(testCase.keywords || []).join(", ")}
                  disabled={disabled}
                  placeholder="e.g. def, print"
                  onChange={(event) => {
                    const keywords = event.target.value
                      .split(",")
                      .map((item) => item.trim())
                      .filter(Boolean);
                    onMetaChange(testCaseIndex, {
                      keywords,
                      type: keywords.length ? "assertion" : "",
                    });
                  }}
                />
              </div>
            </>
          )}
          <div className="form-group">
            <p>Enter Test case {testCaseIndex + 1} values and output:</p>
            <label>Values:</label>
            {(testCase.Value || [""]).map((value, valueIndex) => (
              <div key={valueIndex} className="mb-2 position-relative">
                <input
                  type="text"
                  className="form-control custom-input"
                  value={value}
                  disabled={disabled}
                  onChange={(event) => handleTestCaseValueChange(testCaseIndex, valueIndex, event.target.value)}
                  placeholder={`Enter value ${valueIndex + 1}`}
                />
                {(testCase.Value || []).length > 1 && (
                  <button
                    type="button"
                    className="btn-close position-absolute top-0 end-0"
                    aria-label="Close"
                    disabled={disabled}
                    onClick={() => removeTestCaseValue(testCaseIndex, valueIndex)}
                  />
                )}
              </div>
            ))}
            <button
              type="button"
              className="btn text-light btn-sm mt-1"
              style={{ backgroundColor: "#377383" }}
              disabled={disabled}
              onClick={() => addTestCaseValue(testCaseIndex)}
            >
              Add Value
            </button>
          </div>
          <div className="form-group">
            <label>Output:</label>
            <textarea
              rows="1"
              className="form-control custom-input"
              value={testCase.Output || ""}
              disabled={disabled}
              onChange={(event) => handleTestCaseOutputChange(testCaseIndex, event.target.value)}
              placeholder="Enter output"
            />
          </div>
          {typeof onMetaChange === "function" && (
            <div className="form-group">
              <label>Error message:</label>
              <textarea
                rows="2"
                className="form-control custom-input"
                value={testCase.errorMessage || ""}
                disabled={disabled}
                placeholder="Shown when this test fails"
                onChange={(event) => onMetaChange(testCaseIndex, { errorMessage: event.target.value })}
              />
            </div>
          )}
        </div>
      ))}
      <button
        type="button"
        className="btn text-light btn-sm mt-1"
        style={{ backgroundColor: "#377383" }}
        disabled={disabled}
        onClick={addTestCase}
      >
        Add Test Case
      </button>
    </div>
  );
}

export default PythonTestCases;
